import Api from "../ApiUtility/Api";

class UsersDs {
  constructor() {
    this.api = new Api();
  }

  async WS_CognitoUsers_List(requestData) {
    try {
      const data = await this.api.postAPI(requestData, '/dev/WS_CognitoUsers_List');
      console.log("parsed data", data);

      return data?.data ?? data;
    } catch (error) {
      console.error('Error during WS_CognitoUsers_List API call :', error);
      throw error;
    }
  }

  async WS_Cognito_UserAttributes_UPDATE(requestData) {
    try {
      // Normalize incoming shapes
      const username = requestData.Username || requestData.username;
      const attributes = requestData.UserAttributes || requestData.attributes;

      if (!username || !Array.isArray(attributes)) {
        console.error("Invalid WS_Cognito_UserAttributes_UPDATE payload:", requestData);
        throw new Error("username and attributes are required");
      }

      const normalizedPayload = {
        username,
        attributes,
      };

      console.debug("Sending normalized payload to backend:", normalizedPayload);

      const data = await this.api.postAPI(
        normalizedPayload,
        '/dev/WS_Cognito_UserAttributes_UPDATE'
      );

      return data?.data ?? data;
    } catch (error) {
      console.error('Error during WS_Cognito_UserAttributes_UPDATE API call:', error);
      throw error;
    }
  }

  WS_Congnito_User_Add(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Congnito_User_Add")
      .then((data) => {
        console.log("Users add :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Users ADD API call:", error);
        throw error;
      });
  }

  AP_Dataset_List_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Dataset_List_GET")
      .then((data) => {
        console.log("Dataset List Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Dataset List GET API call:", error);
        throw error;
      });
  }

WS_ChangePassword_ByUser(requestData) {
  return this.api
    .postAPI(requestData, "/dev/WS_ChangePassword_ByUser")
    .then((data) => {
      console.log("Change Password Response :", data);
      return data;
    })
    .catch((error) => {
      console.error("Error during Change Password API call:", error);
      throw error;
    });
}

}

export default UsersDs;
